import _extends from "@babel/runtime/helpers/extends";

/*
 * @Author: wangshengqiang
 * @Date: 2021-04-27 17:29:06
 * @LastEditTime: 2022-02-17 15:15:26
 * @LastEditors: wangshengqiang
 * @Description: 保险起期
 */
import React from 'react';
import moment from 'moment';
import FormItem from '@/baseComponents/FormItem';
import DateSelect from '@/baseComponents/DateSelect'; // values [1, 'D']
// date moment对象
// type 'subtract' | 'add'

export function getDate(value, date = moment(), type = 'add') {
  let [num, unit] = value;
  num = parseFloat(num);
  const typeMap = {
    Y: 'years',
    M: 'months',
    D: 'days'
  };

  if (unit && !Number.isNaN(num) && type === 'add') {
    return date.add(num, typeMap[unit]).format('YYYY-MM-DD');
  }

  if (unit && !Number.isNaN(num) && type === 'subtract') {
    return date.subtract(num, typeMap[unit]).format('YYYY-MM-DD');
  }

  return undefined;
}
export function getDateRange(limit, min, max) {
  const ret = {
    min,
    max
  };

  if (limit) {
    const {
      begin,
      end
    } = limit;

    if (begin) {
      ret.min = getDate(begin);
    }

    if (end) {
      ret.max = getDate(end);
    }
  }

  return ret;
}

const InsuranceStartDate = props => {
  const {
    attrs,
    formKey,
    label,
    remark,
    isRequired,
    isBenefitFactor,
    isPremiumFactor
  } = props;
  const {
    display = {},
    limit = [],
    radioValue = {}
  } = attrs || {};
  const {
    placeholder
  } = display;
  let min = moment().add(1, 'days').format('YYYY-MM-DD');
  let max = moment().add(80, 'days').format('YYYY-MM-DD'); // 1 承保次日 2 指定日期   T+n  T-n
  // 可选日期范围
  // 如果配置的是指定日期,需要设置日期范围

  if (radioValue.value === '2' && limit) {
    const dateRange = getDateRange(limit, min, max);
    min = dateRange.min;
    max = dateRange.max;
  }

  let initialValue;

  if (display.hasDefaultValue && display.defaultValue) {
    const _defaultValue = JSON.parse(display.defaultValue); // defaultValueType 2 指定日期 1 承保次日  T+n  T-n


    if (radioValue.value === '2') {
      initialValue = moment(_defaultValue).format('YYYY-MM-DD');
    } else if (_defaultValue.includes('+')) {
      const n = _defaultValue.split('+')[1] || 0;
      initialValue = moment().add(n, 'days').format('YYYY-MM-DD');
    } else if (_defaultValue.includes('-')) {
      const n = _defaultValue.split('-')[1] || 0;
      initialValue = moment().subtract(n, 'days').format('YYYY-MM-DD');
    }
  } // 承包次日的默认值设置


  if (radioValue.value === '1') {
    initialValue = min;
  }

  const disabled = display.hasDefaultValue && display.defaultValue;
  const formItemProps = {
    name: formKey,
    label,
    remark,
    fieldOption: {
      rules: [{
        required: isRequired,
        message: '请选择'
      }],
      isBenefitFactor,
      isPremiumFactor,
      initialValue
    }
  };
  return /*#__PURE__*/React.createElement(FormItem, _extends({}, props, formItemProps), /*#__PURE__*/React.createElement(DateSelect, {
    title: "\u9009\u62E9\u65E5\u671F",
    placeholder: placeholder,
    mode: "date",
    disabled: disabled,
    min: min,
    max: max
  }));
};

export default InsuranceStartDate;